import {Component, Input, OnInit} from '@angular/core';
import {IndicatorsViewModel} from '../../shared/card-view/indicators-view/indicators-view.model';
import {Unit} from '../../dashboard/monitoring/unit';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {roundUpToTenths} from '../../statistic/statistics-utility-functions';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-charging-station-indicators',
  templateUrl: './charging-station-indicators.component.html',
})
export class ChargingStationIndicatorsComponent implements OnInit {

  public static powerThresholdKW = 0.1;

  @Input() unit: BehaviorSubject<Unit>;
  constructor(
    protected translates: TranslateService,
  ) { }

  iconClasses = {
    'Type 1': 'charging-station-connector-port-type-1',
    'Type 2': 'charging-station-connector-port-type-2',
    'CCS Combo 1': 'charging-station-connector-port-ccs-combo-1',
    'CCS Combo 2': 'charging-station-connector-port-ccs-combo-2',
    'GBT AC': 'charging-station-connector-port-gbt-ac',
    'GBT DC': 'charging-station-connector-port-gbt-dc',
    CHAdeMO: 'charging-station-connector-port-chademo',
    'Tesla Supercharger': 'charging-station-connector-port-tesla-supercharger',
    '230V': 'charging-station-connector-port-230v',
    '32A 4 Pin': 'charging-station-connector-port-32a-4pin',
    '32A 5 Pin': 'charging-station-connector-port-32a-5pin',
  };

  indicators: Observable<Array<IndicatorsViewModel>>;

  getIconTypeClass(connectorType: string): string {
    return connectorType in this.iconClasses ? this.iconClasses[connectorType] : this.iconClasses['230V'];
  }

  getIconStatusClass(unit: Unit, portNumber: string) {
    const inactive = 'charging-station-connector-port-inactive';
    if (!unit.lastMsgUnit || !unit.lastMsgUnit[`port${portNumber}_is_on`]) {
      return inactive;
    }
    return parseFloat(unit.lastMsgUnit[`port${portNumber}_power`]) > ChargingStationIndicatorsComponent.powerThresholdKW ?
      'charging-station-connector-port-active'
      : 'charging-station-connector-port-default';
  }

  getConsumedEnergy(unit: Unit, portNumber: string): number {
    return unit.lastMsgUnit ? roundUpToTenths(unit.lastMsgUnit[`port${portNumber}_consumed_active_energy`]) : 0;
  }
  ngOnInit() {
    this.indicators = this.unit.pipe(
      map(unit => (
        ['01', '02', '03', '04']
          .filter(portNumber => unit.unitModel[`charging_station_port${portNumber}_enabled`])
          .map(portNumber => (
            {
              title: portNumber + ' ' + unit.unitModel[`chargingStationPort${portNumber}ConnectorType`].name,
              iconClass: 'icon-mask '
                + this.getIconTypeClass(unit.unitModel[`chargingStationPort${portNumber}ConnectorType`].name)
                + ' '
                + this.getIconStatusClass(unit, portNumber),
              value: this.getConsumedEnergy(unit, portNumber) + ' ' + this.translates.instant('kWh'),
              isVisible: true,
            }))
        )
      )
    );
  }

}
